import { claimSettlementTypeDef } from "../../enumeration/definitions/claim-settlement-type-def";
import { damageTypeBaseTypeDef } from "../../enumeration/definitions/damage-type-type-def";
import { damageCategoryBaseTypeDef } from "../../enumeration/definitions/damage-category-type-def";
import { partnerBaseTypeDef } from "../../partners/definitions/partner-type-def";
import { taskStateTypeDef } from "./task-state-type-def";
import { employeeTypeDef } from "../../employees/definitions/employee-type-def";
import { insuranceCompanyTypeDef } from "./insurance-company-type-def";
import { taskFileGroupTypeDef } from "../../task-file-group/definitions/task-file-group-type-def";
import { taskFileTypeDef } from "../../taks-file/definitions/task-file-type-def";
import { taskCalculationFileTypeDef } from "../../task-calculation-file/definitions/task-calculation-file-type-def";
import { taskInternalPartnerFileTypeDef } from "../../taks-internal-partner-file/definitions/task-internal-partner-file-type-def";

export const taskTypeDef = `
  id
  assignedTo {
    ${employeeTypeDef}
  }
  canBeEdited
  callerName
  callerPhone
  changedAt
  claimNumber
  claimSettlementType {
    ${claimSettlementTypeDef}
  }
  clientName
  clientPhone
  clientType
  clientIdentificationCode
  createdBy {
    username
    type
  }
  excessPrice
  excessPercent
  createdAt
  damageType {
    ${damageTypeBaseTypeDef}
  }
  damageCategory {
    ${damageCategoryBaseTypeDef}
  }
  dateOfLoss
  description
  externalCode
  taskCalculationFiles {
    ${taskCalculationFileTypeDef}
  }
  taskFiles {
    ${taskFileTypeDef}
  }
  taskInternalPartnerFiles {
    ${taskInternalPartnerFileTypeDef}
  }
  taskFileGroups {
    ${taskFileGroupTypeDef}
  }
  image {
    ${taskFileTypeDef}
  }
  insuranceCompany {
    ${insuranceCompanyTypeDef}
  }
  internalCode
  note
  internalNote
  partner {
    ${partnerBaseTypeDef}
  }
  reviser {
    ${employeeTypeDef}
  }
  state {
    ${taskStateTypeDef}
  }
  type
  updatedAt
  downloadAllFilesUrl
  downloadAllFilesFlatUrl
`;
